// import React, { useEffect, useMemo, useRef } from 'react';
// import { Box, Typography } from '@mui/material';
// import { useParams } from 'react-router-dom';
// import Hls from 'hls.js'; // npm i hls.js
// import { CAMERA_RTSP_URLS } from './Stores/Insight/sideBar'; // adjust import path if needed

// // Choose your approach: 'iframe' (WebRTC player page) or 'hls' (.m3u8 in-app)
// const PLAYER_MODE = 'iframe';

// // If using 'iframe' mode, set a player page that knows how to handle RTSP -> WebRTC/HLS.
// // Many gateways (Ant Media, Wowza, Janus, OvenMediaEngine, rtsp-relay) offer such a page.
// // This page should accept a "src" query param with the RTSP URL.
// const WEBRTC_PLAYER_PAGE = 'https://your-player-host.example.com/rtsp-player'; // expects ?src=RTSP_URL

// // If using 'hls' mode, map each camera to an .m3u8 URL your backend provides.
// const CAMERA_HLS_URLS = {
//   '1': 'https://your-hls-host.example.com/live/stream1.m3u8',
//   '2': 'https://your-hls-host.example.com/live/stream2.m3u8',
//   '3': 'https://your-hls-host.example.com/live/stream3.m3u8',
//   '4': 'https://your-hls-host.example.com/live/stream4.m3u8'
// };

// const CameraPlayer = () => {
//   const { id } = useParams();
//   const videoRef = useRef(null);

//   const rtspSrc = useMemo(() => CAMERA_RTSP_URLS[id], [id]);
//   const hlsSrc = useMemo(() => CAMERA_HLS_URLS[id], [id]);
//   const iframeSrc = useMemo(() => {
//     if (!rtspSrc) return '';
//     const u = new URL(WEBRTC_PLAYER_PAGE);
//     u.searchParams.set('src', rtspSrc);
//     // you can also pass autoplay/mute flags if your player page supports them
//     u.searchParams.set('autoplay', '1');
//     u.searchParams.set('muted', '1');
//     return u.toString();
//   }, [rtspSrc]);

//   useEffect(() => {
//     if (PLAYER_MODE !== 'hls') return;
//     if (!videoRef.current) return;

//     // Clean up previous hls instance if any
//     let hls;
//     const video = videoRef.current;

//     if (Hls.isSupported() && hlsSrc) {
//       hls = new Hls({ enableWorker: true, lowLatencyMode: true });
//       hls.loadSource(hlsSrc);
//       hls.attachMedia(video);
//       hls.on(Hls.Events.MEDIA_ATTACHED, () => {
//         video.muted = true; // allow autoplay
//         video.play().catch(() => {});
//       });
//     } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
//       // Safari native HLS
//       video.src = hlsSrc || '';
//       video.muted = true;
//       video.play().catch(() => {});
//     }

//     return () => {
//       if (hls) {
//         hls.destroy();
//       }
//     };
//   }, [hlsSrc]);

//   return (
//     <Box sx={{ width: '100%', height: 'calc(100vh - 65px)', backgroundColor: 'black' }}>
//       {!rtspSrc && (
//         <Box sx={{ color: 'white', display: 'grid', placeItems: 'center', width: '100%', height: '100%' }}>
//           <Typography variant="h6">Camera not configured.</Typography>
//         </Box>
//       )}

//       {PLAYER_MODE === 'iframe' && rtspSrc && (
//         <iframe
//           key={iframeSrc}
//           src={iframeSrc}
//           title={`Camera ${id}`}
//           allow="autoplay; microphone; camera; fullscreen; picture-in-picture"
//           allowFullScreen
//           style={{ border: 'none', width: '100%', height: '100%', display: 'block', background: 'black' }}
//         />
//       )}

//       {PLAYER_MODE === 'hls' && (
//         <video
//           ref={videoRef}
//           playsInline
//           controls
//           muted
//           style={{ width: '100%', height: '100%', objectFit: 'contain', background: 'black' }}
//         />
//       )}
//     </Box>
//   );
// };

// export default CameraPlayer;




import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

// Same mapping used in Sidebar (duplicate here to keep this file standalone)
const CAMERA_PAGE_URLS = {
  '1': 'http://localhost:8889/stream1/',
  '2': 'http://localhost:8889/stream2/',
  '3': 'http://localhost:8889/stream3/',
  '4': 'http://localhost:8889/stream4/'
};

const CameraPlayer = () => {
  const { id } = useParams();
  const src = useMemo(() => CAMERA_PAGE_URLS[id], [id]);

  if (!src) {
    return (
      <Box sx={{ width: '100%', height: 'calc(100vh - 65px)', display: 'grid', placeItems: 'center', bgcolor: 'black' }}>
        <Typography color="white">Camera {id} is not configured.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 65px)', bgcolor: 'black' }}>
      <iframe
        key={src}
        src={src}
        title={`Camera ${id}`}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        style={{ border: 'none', width: '100%', height: '100%', display: 'block', background: 'black' }}
      />
    </Box>
  );
};

export default CameraPlayer;
